// extracted by mini-css-extract-plugin
export default {"alert":"alert-styles_component_alert__-xRan","centerAlert":"alert-styles_component_centerAlert__xEZcW"};